<template>
  <ButtonToggle
    class="button-toggle"
    :buttonText="text"
    :iconLeft="iconEyeSmall"
    :size="'extra-small'"
    :active="active"
    @onClicked="toggleShowOnMap"
  />
</template>
<script setup lang="ts">
import ButtonToggle from '@/design-system/atoms/buttons/ButtonToggle.vue'
import { computed, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import iconEyeSmall from '@/design-system/assets/icons/Icon-Eye-Small.svg'

type Emits = {
  (e: 'toggleShowOnMap'): void
}

type Props = {
  active: boolean
}

const props = defineProps<Props>()

const { active } = toRefs(props)

const { t } = useI18n()

const emit = defineEmits<Emits>()

const text = computed(() => {
  return active.value ? t('dashboard__text__hide-on-map') : t('dashboard__text__show-on-map')
})

function toggleShowOnMap() {
  emit('toggleShowOnMap')
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';

.button-toggle {
  color: variables.$color-primary;
}
</style>
